module.exports = __webpack_public_path__ + "static/media/linkedin.ca010e52.svg";